module.exports = __webpack_public_path__ + "static/media/price-original.0aed3d9e.png";